<template lang="pug">
span
  icon(:class='icon.class' :name='icon.name')
  span.ms-2 {{ $t(icon.label) }}
</template>

<script>
import Icon from '@/ui/atoms/Icon.vue';

export default {
  name: 'IconEnviromentClient',
  components: {
    Icon,
  },
  props: {
    isSandbox: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    icon() {
      if (this.isSandbox) {
        return {
          name: 'cube',
          label: this.$t('enviroment.sandbox'),
          class: 'icon--sandbox',
        };
      }
      return {
        name: 'cube',
        label: this.$t('enviroment.production'),
        class: 'icon--production',
      };
    },
  },
};
</script>

<style scoped lang="stylus">
.icon--sandbox
  color: #3ECB90 !important
.icon--production
  color: #01AFEC !important
</style>
